import { Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import TableActionButton from '../../ui/TableActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { deleteCountry, fetchCountryList } from '../../../store/slices/country-slice';
import ConfirmDialog from '../../ui/ConfirmDialog';
import TightWrapper from '../../ui/TightWrapper';
import LoadingError from '../../ui/error/LoadingError';

const CountryTable = () => {
    const dispatch = useDispatch();
    const { isLoading, data, isError } = useSelector((state) => state.country);
    const [dataSource, setDataSource] = useState([]);

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }
    
    useEffect(() => {
      dispatch(fetchCountryList());
    }, []);
    
    useEffect(() => {
      if(data.length >= 0) {
        setDataSource(
          data.map((item) => ({
            ...item,
            key: item.country_id,
            edit_id: item.country_id,
            delete_id: item.country_id,
          }))
          );
        }
      }, [data]);
      
      const columns = [
        {
          title: 'Country Name',
          dataIndex: 'country_name',
          key: 'country_name',
        },   
        {
          title: 'Updated On',
          dataIndex: 'addedOn',
          key: 'addedOn',
          render: (_, { addedOn }) => addedOn && addedOn.split(' ')[0]
        },
        {
          title: 'Edit',
          dataIndex: 'edit_id',
          key: 'edit_id',
          render: (_, {edit_id}) => (
            <TightWrapper>
              <Link to={`/dashboard/country-form?mode=EDIT&id=${edit_id}`}>
                <TableActionButton bg='#10ac84'>Edit</TableActionButton>
              </Link>
            </TightWrapper>
          )
        },
        {
          title: 'Delete',
          dataIndex: 'delete_id',
          key: 'delete_id',
          render: (_, {delete_id}) => (
            <ConfirmDialog
                onConfirm={() => dispatch(deleteCountry({ id: delete_id }))}
              >
              <TightWrapper>
                <TableActionButton bg='#ff6b6b' >Delete</TableActionButton>
              </TightWrapper>
            </ConfirmDialog>
          )
        },
      ].filter((item) => !nullColumns.includes(item.key));;
      
    if(isLoading) return (
      <Spin
          tip="Loading" 
          size="large" 
          className='loading-spiner'
      />
    );
    if(isError) return <LoadingError />;

    return (
        <Wrapper>
            <Title>Countries</Title>
            <div className='card'>
                <Table 
                dataSource={dataSource}
                bordered
                size='medium'
                columns={columns} 
                style={{
                    marginTop: '10px',
                    padding: 0,
                }}
                />
            </div>
        </Wrapper>
    );
}

export default CountryTable;



const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    overflow: auto;
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

